import {useParams} from 'react-router'
import {DatingSafetyPolicyModal} from 'features/datingSafetyPolicyModal/ui'
import {VideoPlayer} from 'features/videoPlayer'
import {WarningModalProvider} from 'features/warningModal/context'
import {ChatHeader} from '../chatHeader'
import {ChatMessagesList} from '../chatMessagesList'
import styles from './styles.module.scss'

export const Chat = () => {
  const {id} = useParams()

  return (
    <WarningModalProvider>
      {
        id
          ? <div className={styles.chat}>
            <ChatHeader idUser={id} />
            <ChatMessagesList userId={id} />
          </div>
          : <div className={styles.chatNotDialog}>
            <span className={styles.text}>Please select a dialogue</span>
          </div>
      }
      <VideoPlayer />
      <DatingSafetyPolicyModal />
    </WarningModalProvider>
  )
}
